import api from '../services/api';
import getHeaders from '../utils/returnHeaders';

// US-18: cidade e data agora sao OPCIONAIS; US-19: filtro por categoria/subcategoria.
// Monta a query enviando somente os parametros preenchidos (omite vazios/nulos).
const getExperiences = async (cityId, startDate, endDate, categoryId, subcategoryIds) => {
  const header = getHeaders();
  const params = new URLSearchParams();
  if (cityId) params.append('cityId', cityId);
  if (startDate) params.append('startDate', startDate);
  if (endDate) params.append('endDate', endDate);
  if (categoryId) params.append('categoryId', categoryId);
  /* Aceita id unico ou array. O backend recebe como lista separada por virgula
     (demanda 231: a Vitrine permite escolher varias subcategorias). */
  if (subcategoryIds) {
    const lista = Array.isArray(subcategoryIds)
      ? subcategoryIds.filter(Boolean).join(',')
      : String(subcategoryIds);
    if (lista) params.append('subcategoryIds', lista);
  }
  const query = params.toString();
  return api.get(`/experience${query ? `?${query}` : ''}`, header);
};

export { getExperiences };
